import { Button, Typography } from "@mui/material"
import BlockingScreenLayer from "../components/common/containers/BlockingScreenLayer";
import { FULLY_BLOCKING_POPUP_ZINDEX as zIndex } from "../utils/constants/otherConstants";
import LoadingCircle from "../components/loading/LoadingCircle";

const LoginPage = ({authUrl, authenticating}) => {
    const onClick = () => {
        window.location.href = authUrl.toString();
    }

    return (
        <>
            {
                authenticating &&
                <BlockingScreenLayer zIndex={zIndex} backgroundOpacity={0.5}>
                    <div className="full-width full-height d-flex jc-center ai-center">
                        <LoadingCircle />
                    </div>
                </BlockingScreenLayer>
            }
            <div className="full-width full-height d-flex flex-column ai-center jc-center gap-1">
                <Typography variant="h3">albuMania</Typography>
                <Typography variant="h5">Login page</Typography>
                <Button disabled={!authUrl || authenticating} onClick={onClick}
                    variant="contained"
                    color="secondary">
                    Access to Spotify login
                </Button>
            </div>
        </>
    )
}

export default LoginPage;